<template>
  <div v-if="show">
    <li class="infoList">
      <span class="infoListLeft">{{dataInfo.label}}</span>
      <span class="infoListRight">{{judge(dataInfo)}} </span>
    </li>
  </div>
</template>

<script>
export default {
  name: 'ContractInfo',
  props: {
    dataInfo: {},
    pageData: {},
  },
  computed: {
    show() {
      const { inShowField } = this.dataInfo;
      if (inShowField) {
        if (this.pageData[inShowField] === this.dataInfo.condition) {
          return true;
        }
        return false;
      }
      return true;
    },
  },
  methods: {
    judge(item) {
      if (item.key !== 'execRate') {
        return item.value ? `${item.firstUnit || ''} ${item.value} ${item.lastUnit || ''}` : '--';
      }
      return item.value ? `${item.firstUnit || ''} ${parseFloat(item.value).toFixed(2)} ${item.lastUnit || ''}` : '--';
    },
  },
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
}
.infoListLeft {
  color: rgba(56, 56, 56, 1);
  font-size: 14px;
}
.infoListRight {
  color: rgba(128, 128, 128, 1);
  font-size: 14px;
}
</style>
